import BedsList from "./BedsList";

export default BedsList;